import { NetworkRequestState } from '../baseTypes';
import { MutedTagsWidgetData } from './types';

const defaultMutedTagsWidgetData: NonNullable<
  MutedTagsWidgetData['initialData']
> = {
  blacklistedTags: [],
};

export const defaultMutedTagsWidgetState: MutedTagsWidgetData = {
  initialData: defaultMutedTagsWidgetData,
  currentData: defaultMutedTagsWidgetData,
  isDirty: false,
  saveRequest: {
    status: NetworkRequestState.IDLE,
  },
};
